import TspApiService from "../api/tspApiService";
import useTspApiResource from "./useTspApiResource";

// The journey and city choices for a filter bar (Media Gallery, Advice
// Repository). Both are optional conveniences: a role without journey or
// location access simply gets fewer entries — the page itself still works.
export default function useTspJourneyLocationOptions() {
  const journeys = useTspApiResource(() => TspApiService.listJourneys({ sort: "journey_name", order: "asc", limit: 100 }).catch(() => ({ data: [] })), []);
  const locations = useTspApiResource(() => TspApiService.listLocations({ limit: 100 }).catch(() => ({ data: [] })), []);
  return { journeys: journeys.data || [], locations: locations.data || [] };
}
